import { createComponent } from '@front/utils/alpine';
const Pagination = createComponent(() => ({
    isLoading: false,
    counter: 0,
    async nextPage(nextPageUrl) {
        this.isLoading = true;
        try {
            const response = await fetch(nextPageUrl, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                signal: new AbortController().signal,
            });
            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }
            const data = await response.text();
            this.appendItemsToList(data);
        }
        catch (error) {
            console.error(`Fetching next page failed for URL: ${nextPageUrl}`, error);
        }
        finally {
            this.isLoading = false;
        }
    },
    appendItemsToList(data) {
        const parser = new DOMParser();
        const page = parser.parseFromString(data, 'text/html');
        const newItems = page.querySelectorAll('.js-items-list > *');
        const list = this.$refs.rendered_list;
        const nextButtonContainer = this.$refs
            .rendered_items_bottom;
        const newNextButton = page.querySelector('.js-items-bottom');
        if (list && nextButtonContainer) {
            newItems.forEach((item) => {
                list.appendChild(item);
            });
            this.counter += newItems.length;
            if (newNextButton) {
                nextButtonContainer.innerHTML = newNextButton.innerHTML;
            }
            else {
                nextButtonContainer.remove();
            }
        }
        else {
            console.warn('List or next button container is missing in the DOM');
        }
    },
}));
export { Pagination };
